import type { MouseEvent, Ref } from 'react'
import * as S from './ClassicResizeControls.styled'

type ClassicResizeHandleElementProps = {
  x?: number
  y?: number
  z?: number
  height?: number | string
  width?: number | string
  position?: string
  selected?: boolean
  innerRef?: Ref<HTMLDivElement>
  itemLocked?: boolean
  onMouseDown?: (e: MouseEvent<HTMLDivElement>) => void
  itemId?: string
}

/**
 * The functional south-east handle of a classic (TinyMCE-era) item,
 * identical to staging's: it takes the pointer itself when the item is
 * selected and unlocked, and the overlay's wedge forwards its mousedown here
 * as well.
 */
export const ClassicResizeHandleElement = ({
  x,
  y,
  z,
  height,
  width,
  position,
  selected,
  innerRef,
  itemLocked,
  onMouseDown,
  itemId,
}: ClassicResizeHandleElementProps) => {
  return (
    <S.ClassicResizeHandle
      className="no-drag"
      ref={innerRef}
      x={x}
      y={y}
      z={z}
      height={height || 0}
      width={width || 0}
      position={position}
      selected={selected}
      onMouseDown={onMouseDown}
      $itemLocked={itemLocked}
      data-resize-handle={itemId}
    />
  )
}

ClassicResizeHandleElement.displayName = 'ClassicResizeHandleElement'
